import { render, staticRenderFns } from "./Voter.vue?vue&type=template&id=c35d1dc8&"
import script from "./Voter.vue?vue&type=script&lang=js&"
export * from "./Voter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports